<template>
  <div class="sider_7">
    <div class="title">{{ cTagName }}</div>
    <div class="department">
      <ul>
        <li v-for="(item, index) in this.cSystemScenceList_sys" :key="index">
          <a :href="item.sysLink" target="_blank">
            <img :src="item.picPath" alt="" />
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-silder-system",
  components: {},
  props: {
    cSystemScenceList_sys: {
      type: Array,
      default: function () {
        return [];
      },
    },
    cTagName: {
      default: "相关业务系统",
    },
  },
  data() {
    return {
      listBefore: [],
      list: [],
    };
  },
  watch: {},
  computed: {},
  methods: {
    getArr() {
      for (let i = 0; i < this.cSystemScenceList.length; i++) {
        if (this.cSystemScenceList[i].sysType == 0) {
          this.list.push(this.cSystemScenceList[i]);
        }
      }
    },
  },
  created() {
    // this.getArr();
  },
  mounted() {},
};
</script>

<style lang='less' scoped>
.fr {
  float: right;
}
.sider_7 {
  width: 100%;
  margin-bottom: 20px;
  .title {
    width: 100%;
    height: 24px;
    font-size: 16px;
    font-weight: bold;
    padding-bottom: 10px;
  }
  .department {
    width: 100%;
    // margin-left: 20px;
    margin-bottom: 10px;
    ul {
      margin: 0;
      padding: 0;
      li {
        display: inline-block;
        width: 100%;
        height: 80px;
        margin-bottom: 20px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>